import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

import { UserFacade } from '@personal-area/global/users/services';

@Injectable({ providedIn: 'root' })
export class FixRateService {

  private _localCurrencyMap: Map<string, string>;
  private _countryCurrencyMap: Map<string, string>;
  private _ratesMap: Map<string, number>;

  constructor(
    private _userFacade: UserFacade,
  ) {
    // TODO move maps, fixRateCountries, fixRateCurrencies to FireBase
    this._countryCurrencyMap = new Map<string, string>([
      ['IDN', 'USF'],
      ['THA', 'USB'],
      ['NGA', 'USN'],
    ]);
    this._localCurrencyMap = new Map<string, string>([
      ['USF', 'IDR'],
      ['USB', 'THB'],
      ['USN', 'NGN'],
    ]);
    this._ratesMap = new Map<string, number>([
      ['USF', 10000],
      ['USB', 33],
      ['USN', 400]
    ]);
  }

  public fixRateEnabled(): boolean {
    return environment.fixRateCountries?.includes(this._userFacade.loggedUser.country);
  }

  public getCurrencyByCountry(): string {
    return this._countryCurrencyMap.get(this._userFacade.loggedUser.country) || 'USD';
  }

  public getLocalCurrencyByCountry(): string {
    return this._localCurrencyMap.get(this.getCurrencyByCountry()) || 'USD';
  }

  public getOriginalCurrency(currency: string): string {
    return environment.fixRateCurrencies?.includes(currency) ? 'USD' : currency;
  }

  public get fixRateCurrencies(): string[] {
    return environment.fixRateCurrencies;
  }

  public getCurrencyRateByCountry(): number {
    return this.getCurrencyRate(this.getCurrencyByCountry());
  }

  public getCurrencyRate(currency: string): number {
    return this._ratesMap.get(currency);
  }
}
